

export interface TokenInfo {
  token: string;
  expiry: Date;
  isExpired: boolean;
  expiresInMinutes: number;
}


export function parseTokenInfo(token: string): TokenInfo | null {
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    
    const expiry = new Date(payload.exp * 1000);
    const now = new Date();
    const isExpired = expiry <= now;
    const expiresInMinutes = Math.floor((expiry.getTime() - now.getTime()) / (1000 * 60));

    return {
      token,
      expiry,
      isExpired,
      expiresInMinutes
    };
  } catch (error) {
    return null;
  }
}


export function convertUTCToLocal(utcDateString: string): Date {
  return new Date(utcDateString);
}


export function isTokenExpiring(token: string, minutesBuffer: number = 2): boolean {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    
    const expiry = payload.exp;
    const now = Math.floor(Date.now() / 1000);
    
    const bufferSeconds = minutesBuffer * 60;
    const isExpiring = expiry <= (now + bufferSeconds);
    
    
    return isExpiring;
  } catch (error) {
    return true;
  }
}

